import angular from 'angular';

import CalendarSelectModalComponent from './calendar-select-modal.cmpt';

export default angular
    .module('application.component.modals.component.calendar-select-modal', [])
    .component(CalendarSelectModalComponent.selector, CalendarSelectModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/calendar-select-modal/index.js